<template>
    <span v-if="this.user.owner">
        <b-button
            @click="handleImpersonateGuestClick"
            title="Login As Guest"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'circle-user']"></font-awesome-icon>
        </b-button>
        <modal
            :id="impersonateGuestConfirmModalID"
            title="Please Confirm"
            ok-title="OK"
            @ok="handleLoginAsGuest"
            @shown="onModalShown"
        >
            Are you sure you want to login as guest: <b>({{ this.user.id }}) {{ this.user.email }}</b>?
        </modal>
    </span>
</template>

<script>
import get from 'lodash/get';
import Modal from '../../generic/modal/modal.vue';
import API from '../../../api';
import { STAYLIO_APP_STATISTICS_USER_ENDPOINT } from '../../../endpoints';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            user: null,
            impersonateGuestConfirmModalID: '',
        };
    },
    created() {
        this.user = this.params.data.user;
        this.impersonateGuestConfirmModalID = `staylio-admin-impersonate-login-confirm-modal-${this.user.id}`;
    },
    methods: {
        get,
        onModalShown() {
            this.params.api.clearFocusedCell();
        },

        
        handleImpersonateGuestClick() {
            this.$bvModal.show(this.impersonateGuestConfirmModalID);
        },
        async handleLoginAsGuest() {
            const { data } = await API.get(`${STAYLIO_APP_STATISTICS_USER_ENDPOINT()}impersonate-guest/`, {
                params: {
                    guest_id: this.user.id,
                },
            });
            const url = data.url;
            window.open(url, '_blank');
        },
    }
}
</script>
